if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"OP-WRAPPER","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(8(17|58|88|90)|136|602|657|742|970)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}